import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
export var dataLayerPushWithQueue = function dataLayerPushWithQueue(data) {
  var _window2, _window2$dlcmglu, _window2$dlcmglu$cach;
  var usePriorityQueue = process.env.NODE_ENV === 'production';
  if (!usePriorityQueue) {
    var _window, _window$dataLayer;
    (_window = window) == null ? void 0 : (_window$dataLayer = _window.dataLayer) == null ? void 0 : _window$dataLayer.push(data);
    return;
  }
  var cacheKey = window.location.pathname;
  window.dlcmglu = window.dlcmglu || {};
  window.dlcmglu[cacheKey] = window.dlcmglu[cacheKey] || {
    list: [],
    seen: false
  };
  if ((_window2 = window) == null ? void 0 : (_window2$dlcmglu = _window2.dlcmglu) == null ? void 0 : (_window2$dlcmglu$cach = _window2$dlcmglu[cacheKey]) == null ? void 0 : _window2$dlcmglu$cach.seen) {
    var _window3, _window3$dataLayer;
    (_window3 = window) == null ? void 0 : (_window3$dataLayer = _window3.dataLayer) == null ? void 0 : _window3$dataLayer.push(data);
    return;
  }
  var hasPriority = (data == null ? void 0 : data.event) === 'virtualPageview';
  if (!hasPriority) {
    var _window4, _window4$dlcmglu;
    (_window4 = window) == null ? void 0 : (_window4$dlcmglu = _window4.dlcmglu) == null ? void 0 : _window4$dlcmglu[cacheKey].list.push(data);
  } else {
    var _window5, _window5$dataLayer, _window6, _window7, _window7$dlcmglu;
    (_window5 = window) == null ? void 0 : (_window5$dataLayer = _window5.dataLayer) == null ? void 0 : _window5$dataLayer.push(data);
    if (((_window6 = window) == null ? void 0 : _window6.dataLayer) && ((_window7 = window) == null ? void 0 : (_window7$dlcmglu = _window7.dlcmglu) == null ? void 0 : _window7$dlcmglu[cacheKey].list)) {
      var _window8, _window8$dataLayer, _window9, _window9$dlcmglu;
      (_window8 = window) == null ? void 0 : (_window8$dataLayer = _window8.dataLayer) == null ? void 0 : _window8$dataLayer.push.apply(_window8$dataLayer, _toConsumableArray((_window9 = window) == null ? void 0 : (_window9$dlcmglu = _window9.dlcmglu) == null ? void 0 : _window9$dlcmglu[cacheKey].list));
      window.dlcmglu[cacheKey] = {
        list: [],
        seen: true
      };
    }
  }
};